









































import { Component, Mixins } from 'vue-property-decorator';
import AccountSettings from '@/mixins/accountSettings.mixin';
import cartStore from '@/store/modules/checkout/cart/module';
import InfoAlert from '@/components/familyPortal/checkout/infoAlert/InfoAlert.vue';
import APP_CONST from '@/constants/AppConst';
import { PaymentPlans } from '@/Model/checkout/cart/types';

@Component({
  components: {
    InfoAlert
  }
})
export default class CheckoutPaymentPlanSelector extends Mixins(AccountSettings) {
  public currentPaymentPlanSelection = 0;
  public sessionPriceDecimalPrecision = APP_CONST.SESSION_PRICE_DECIMAL_PRECISION;

  get paymentPlanInfo() {
    return cartStore.paymentPlanInfo;
  }

  get unavailablePaymentPlanTitle () {
    return 'Payment plans unavailable';
  }

  get unavailablePaymentPlanDescription () {
    return `Payment plans unavailable for orders under $${this.paymentPlanInfo && this.paymentPlanInfo.minOrderAmount}.`;
  }

  openPaymentScheduleModal(paymentPlanItem: PaymentPlans) {
    this.$emit('openPaymentScheduleModal', paymentPlanItem);
  }
}
